var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"loading_visible"},[_c('v-progress-circular',{attrs:{"size":100,"width":7,"color":"purple","indeterminate":""}}),_c('div',[_vm._v(_vm._s(_vm.message))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }